import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "../../store/THeme/themeSlicer";

const TopHeader = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { theme } = useSelector((state) => state.themeSlicer);
  const dispatch = useDispatch();

  const handleThemeChange = (selectedTheme) => {
    dispatch(setTheme(selectedTheme.toLowerCase()));
    setIsDropdownOpen(false);
  };

  const themeIcon =
    theme === "light" ? (
      <>
        Light <i className="fa-regular fa-sun"></i>
      </>
    ) : (
      <>
        Dark <i className="fa-solid fa-moon"></i>
      </>
    );

  return (
    <div id="top-bar">
      <div className="container-fluid">
        <div className="row">
          <div className="top-bar-content col-6 align-content-center d-lg-flex d-none">
            <div className="inner text-white link-style-2">
              <span className="phone content section-16px-regular">
                <a href="tel:012345678">(+706) 898-0752</a>
              </span>
              <span className="mail content section-16px-regular">
                <a href="mailto:olux.design@gmail.com">olux.design@gmail.com</a>
              </span>
            </div>
          </div>
          <div className="col-lg-6 col-12 ">
            <div className="top-icons d-flex justify-content-lg-end justify-content-between align-items-center">
              <div className="language d-flex justify-content-center align-items-center mx-4">
                <i className="fa-solid fa-globe text-white mx-2"></i>EN
              </div>
              <li className="theme-mode">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="theme-button"
                >
                  {themeIcon}
                </button>
                {isDropdownOpen && (
                  <ul className="sub-drop">
                    <li
                      className="drop-item"
                      onClick={() => handleThemeChange("Light")}
                    >
                      Light <i className="fa-regular fa-sun"></i>
                    </li>
                    <li
                      className="drop-item"
                      onClick={() => handleThemeChange("Dark")}
                    >
                      Dark <i className="fa-solid fa-moon"></i>
                    </li>
                  </ul>
                )}
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
